function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import flatnest from "flatnest";

var I18n = /*#__PURE__*/function () {
  function I18n(dictionary) {
    _classCallCheck(this, I18n);

    this.dictionary = {};
    this.missing = {};
    this.append(dictionary);
    window.i18n = this;
  }

  _createClass(I18n, [{
    key: "get",
    value: function get(key) {
      var def = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (!Array.isArray(key)) key = [key];
      def = def !== null ? def : _toConsumableArray(key).pop();
      key = _toConsumableArray(key).join('.').toLowerCase();
      if (typeof this.dictionary[key] === "string") return this.dictionary[key];else {
        if (typeof this.missing[key] === "undefined") {
          console.warn('i18n missing: ', key);
          this.missing[key] = def;
        }

        return def;
      }
    }
  }, {
    key: "append",
    value: function append(dictionary) {
      dictionary = flatnest.flatten(dictionary);
      Object.assign(this.dictionary, dictionary);
    }
  }, {
    key: "debug",
    value: function debug() {
      console.log('Dictionary', this.dictionary);
      console.log('Missing', this.missing);
      console.log('Missing-export', JSON.stringify(flatnest.nest(this.missing), null, 2));
    }
  }]);

  return I18n;
}();

export { I18n as default };